/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminPalletOrderLookupItem,
    AdminPalletOrderLookupItemFromJSON,
    AdminPalletOrderLookupItemFromJSONTyped,
    AdminPalletOrderLookupItemToJSON,
} from './AdminPalletOrderLookupItem';

/**
 * 
 * @export
 * @interface AdminPalletOrderLookupResponse
 */
export interface AdminPalletOrderLookupResponse {
    /**
     * 
     * @type {Array<AdminPalletOrderLookupItem>}
     * @memberof AdminPalletOrderLookupResponse
     */
    items: Array<AdminPalletOrderLookupItem>;
}

export function AdminPalletOrderLookupResponseFromJSON(json: any): AdminPalletOrderLookupResponse {
    return AdminPalletOrderLookupResponseFromJSONTyped(json, false);
}

export function AdminPalletOrderLookupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPalletOrderLookupResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(AdminPalletOrderLookupItemFromJSON)),
    };
}

export function AdminPalletOrderLookupResponseToJSON(value?: AdminPalletOrderLookupResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(AdminPalletOrderLookupItemToJSON)),
    };
}

